export const initialState = {
  attribute: {
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnPropertyChanged':
      return onPropertyChanged(state, action);
    case 'OnAttributeTestingFieldsChanged':
      return onAttributeTestingFieldsChanged(state, action);
    case 'OnEngineAttributeAdd':
      return onEngineAttributeAdd(state);
    case 'OnSave':
      return onSave(state);

    default:
      return state;
  }
}

function onInitState(state, action) {
  const { engineAttribute } = action;
  return {
    ...state,
    attribute: {
      ...state.attribute,
      id: engineAttribute?.engineAttributeId,
      orderNo: engineAttribute?.orderNo,
      attributeName: engineAttribute?.attributeName,
      description: engineAttribute?.description,
      expression: engineAttribute?.expression,
      executionOrder: engineAttribute?.executionOrder,
      sensitiveInfo: engineAttribute?.sensitiveInfo == null ? false : engineAttribute?.sensitiveInfo,
      entityIdentifierForTest: '',
      scoringGridId: null,
      scoringGridName: '',
      changed: false
    }
  };
}

function onPropertyChanged(state, action) {
  const { propertyName, propertyValue } = action;
  return {
    ...state,
    attribute: {
      ...state.attribute,
      [propertyName]: propertyValue,
      changed: true
    }
  };
}

function onAttributeTestingFieldsChanged(state, action) {
  const { propertyName, propertyValue } = action;
  return {
    ...state,
    attribute: {
      ...state.attribute,
      [propertyName]: propertyValue
    }
  };
}

function onEngineAttributeAdd(state) {
  return {
    ...state,
    attribute: {
      ...state.attribute,
      id: null,
      orderNo: null,
      attributeName: '',
      description: '',
      expression: '',
      sensitiveInfo: false,
      changed: false
    }
  };
}

function onSave(state) {
  return {
    ...state,
    attribute: {
      ...state.attribute,
      changed: false
    }
  };
}
